//@ts-check
/** @typedef {import("./game_lists/GameList.js").GameListType} GameListType */
/** @typedef {import("./game_lists/GameList.js").GameType} GameType */

/**
 * 
 * @param {string} userAgent 
 * @param {number} screenWidth 
 * @param {number} screenHeight 
 * @returns {boolean}
 */
export function isMobile(userAgent, screenWidth = 1, screenHeight = 1) {
    // ensure that "height" is longer dimension for calculations
    if (screenWidth > screenHeight) {
        const temp = screenHeight;
        screenHeight = screenWidth;
        screenWidth = temp;
    }
    if (!userAgent) {
        return false;
    }

    userAgent = userAgent.toLowerCase()
    if (/(ipad|tablet)/.test(userAgent)) {
        return false; // tablet!
    }

    if (/webos|iphone|ipod|blackberry|bb|playbook|iemobile|windows phone|kindle|silk|opera mini/.test(userAgent)) {
        return true; // mobile!
    }

    const ratio = screenHeight / screenWidth;
    if (/android/.test(userAgent)) {
        const isTablet = (screenHeight > 1100 && ratio > 0.67) || (screenHeight > 1200 && ratio > 0.62);
        return !isTablet
    }

    if (/mobi/.test(userAgent)) {
        return true; // other mobiles
    }

    return false; //desktop
}

/**
 * 
 * @param {*} address 
 * @returns {URL}
 */
export function safeCreateUrl(address) {
    /** @type {URL} */
    let retUrl;
    try {
        retUrl = new URL(address);
    } catch (e) {
        console.error(e);
        throw new Error("Wrong url format: " + address);
    }
    return retUrl;
}

/**
 * 
 * @param {string} gameId 
 * @param {GameListType} gameList 
 * @returns {GameType|undefined}
 */
export function findGame(gameId, gameList) {
    return gameList.find(game => game.id === gameId);
}